/* eslint-disable no-underscore-dangle, no-nested-ternary, prefer-destructuring */
import moment from 'moment'

import { formatDateTime } from '../formats'

export const assignTime = data => {
  const { hour, minute, second, timezone, returnAs, isStartTime, isEndTime, returnInFormat, isForPOST } = data
  let value = data.value

  // biome-ignore lint/complexity/useOptionalChain: TODO
  if (value && value.value && moment.isMoment(value.value)) {
    value = value.value
  }

  if (!moment.isMoment(value)) {
    return value
  }

  const timezoneValue = timezone || moment.tz.guess()
  const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ'

  const hourValue = isStartTime ? '00' : isEndTime ? '23' : hour
  const minuteValue = isStartTime ? '00' : isEndTime ? '59' : minute
  const secondValue = isStartTime ? '00' : isEndTime ? '00' : second

  if (isForPOST) {
    const newValue = formatDateTime({
      isDateOnly: false,
      value,
      style: 2,
      timezone,
    })
    const initialValue = formatDateTime({
      isDateOnly: false,
      value: moment(value._i),
      style: 2,
      timezone,
    })

    let newDateTime

    if (newValue === initialValue) {
      const existingTimeValue = value._i.match(/T\d+:\d+:\d+/g)
      const correctTimeValue = `T${hourValue}:${minuteValue}:${secondValue}`

      if (existingTimeValue.length > 0 && existingTimeValue[0] !== correctTimeValue) {
        newDateTime = moment.utc(value._i.replace(existingTimeValue[0], correctTimeValue), dateTimeFormat)
        newDateTime = moment.utc(newDateTime._i, dateTimeFormat).format()

        return newDateTime
      }

      newDateTime = moment.utc(value._i, dateTimeFormat).format()

      return newDateTime
    }

    const offset = moment(value).tz(timezone).format('Z')
    const monthValue = value.month() < 9 ? '0'.concat(value.month() + 1) : value.month() + 1
    const dateValue = value.date() < 10 ? '0'.concat(value.date()) : value.date()

    newDateTime = `${value.year()}-${monthValue}-${dateValue}T${hourValue}:${minuteValue}:${secondValue}${offset}`
    newDateTime = moment.utc(newDateTime, dateTimeFormat)

    return newDateTime.format()
  }

  const newValue = moment(value).set({
    hour: hourValue,
    minute: minuteValue,
    second: secondValue,
  })

  switch (returnAs) {
    case 'local':
      return returnInFormat ? newValue.format() : newValue
    default: {
      const offset = moment(newValue).tz(timezoneValue).format('Z')
      const newDateTime = newValue.utcOffset(offset, true)

      return returnInFormat ? newDateTime.utc().format() : newDateTime.utc()
    }
  }
}

/**
 * @param {*} birthdate
 * @param {*} [timezone]
 * @param {*} [targetDate]
 */
export function calculateAge(birthdate, timezone, targetDate) {
  const birthStr = moment(birthdate).format('YYYY-MM-DD')
  const birth = timezone ? moment.tz(birthStr, timezone) : moment(birthdate)
  if (!targetDate) {
    // compare with current dt
    const currentTime = timezone ? moment.tz(timezone) : moment()
    const age = currentTime.diff(birth, 'y')
    return age
  }
  const target = timezone ? moment.tz(targetDate, timezone) : moment(targetDate)
  const age = target.diff(birth, 'y')
  return age
}

export const convertAmPmTo24Hour = (hours, ampm) => {
  if (ampm && ampm.toLowerCase() === 'pm' && hours !== 12) {
    return hours + 12
  } else if (ampm && ampm.toLowerCase() === 'am' && hours === 12) {
    return 0
  }
  return hours
}
